<template>
  <div id="app">



    <div class="wrapper">
  <div class="box header">Hyreshjälpen</div>
  <div class="box sidebar">
    <ul class="menu">
      <li>
        <router-link v-bind:to="'/'">Hyreshjälpen</router-link>
      </li>
      <li>
        <router-link v-bind:to="'/hyra-ut-bostadsratt'">Hyra ut bostadsrätt</router-link>
    </li>
    <li>
      <router-link v-bind:to="'/kostnadsbaserad-hyra'">Kostnadsbaserad hyra</router-link>
  </li>
  <li>
    <router-link v-bind:to="'/hyra-ut-rum'">Hyr ut rum</router-link>
</li>
    </ul>
  </div>
  <div class="box content">
    <!-- the router outlet, where all matched components would ber viewed -->
    <router-view></router-view>
  </div>
  <div class="box footer">Hyreshjälpen är en gratis sajt för att informera om hyrestagares rättigheter.</div>
</div>






<div id="container">






</div>



  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<!-- styling for the component -->
<style>
html,body{
  background-color: #ececec;
}

h2{
  font-size:24px;
}
h1{
  font-size:30px;
}
p{
  font-size:18px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}
ul.menu{
list-style-type: none;
margin:0;
padding:0;

}
ul.menu li{
  list-style-type: none;
  margin:0;
  padding:0;
}

ul.menu li a{
  font-size: 16px;
  display:block;
  border-bottom: 1px solid #ececec;
  padding: 10px;
  text-decoration: none;
  color:#6b6b6b;
}
ul.menu li a:hover{
}

.router-link-exact-active{
  background-color: #6b6b6b;
  color:#e2e2e2 !important;
}
.sidebar {
  grid-area: sidebar;
}

.content {
  grid-area: content;
  position: relative;
  max-width:600px;
  margin:auto;
}

.header {
  grid-area: header;
}

.footer {
  grid-area: footer;
}

.wrapper {
        display: grid;
    grid-gap: 10px;
        /*grid-template-columns: 200px 200px 200px;*/
        grid-template-columns: 200px;
        grid-template-areas:
    "header  header  header"
        "sidebar content content"
        "footer  footer  footer";
        background-color: #fff;
        color: #444;
    }


.box {
  background-color: #fff;
  color: #6d6d6d;
  border-radius: 5px;
  padding: 10px;
  font-size: 150%;
}

.header,
.footer {
  background-color: #b3c329;
  color: #2d2d2d;
}

.header{
  color: #2d2d2d;
    font-size: 30px;
    font-weight: 700;
}

.footer{
  font-size:12px;
}

.topleft {
  position: absolute;
  top: 0;
  left: 0;
}

.topright {
  position: absolute;
  top: 0;
  right: 0;
}

.bottomleft {
  position: absolute;
  bottom: 0;
  left: 0;
}

.bottomright {
  position: absolute;
  bottom: 0;
  right: 0;
}

a, a:visited{
  color: #737bff;
}
</style>



// WEBPACK FOOTER //
// App.vue?1aba77b9